import { LockOutlined } from '@mui/icons-material';
import { IconButton, styled, Tooltip, Typography } from '@mui/material';
import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';

import { MaskedValueVariant } from './MaskedValue.types';

const variantTextMap: Record<MaskedValueVariant, string> = {
  [MaskedValueVariant.TEXT]: 'Secured Text',
  [MaskedValueVariant.DECIMAL]: '0.000,00',
  [MaskedValueVariant.CURRENCY]: '€ 0.000,00',
  [MaskedValueVariant.DATE]: 'YYYY/MM/DD',
  [MaskedValueVariant.PERCENTAGE]: '000,00 %',
};

const StyledTypography = styled(Typography)({
  filter: 'blur(5px)',
  userSelect: 'none',
});

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  boxShadow: theme.shadows[2],
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: theme.palette.background.default,
  '&:hover': {
    backgroundColor: theme.palette.grey[200],
  },
}));

export interface MaskedValueProps {
  isMasked: boolean | undefined;
  variant?: MaskedValueVariant;
}
export const MaskedValue = ({
  isMasked = false,
  variant = MaskedValueVariant.TEXT,
  children,
}: PropsWithChildren<MaskedValueProps>) => {
  const { t } = useTranslation(I18nNamespace.common, { keyPrefix: 'CompetitiveBidding' });
  return isMasked ? (
    <Tooltip placement="top" title={t('maskedValueTooltip')}>
      <span style={{ position: 'relative' }}>
        <StyledTypography>{variantTextMap[variant]}</StyledTypography>
        <StyledIconButton size="small">
          <LockOutlined fontSize="small" />
        </StyledIconButton>
      </span>
    </Tooltip>
  ) : (
    children
  );
};
